import { Center, Stack, StackProps } from '@mantine/core'

import styles from './DashboardCardShell.module.css'

export function DashboardCardShell({ children, ...props }: StackProps) {
  return (
    <Center miw={200}>
      <Stack w="100%" className={styles.card} {...props}>
        {children}
      </Stack>
    </Center>
  )
}
